import { View, Button, Autocomplete, Grid, useTheme, Flex, Text } from '@aws-amplify/ui-react';
import { useState, useEffect } from 'react';
import { generateClient } from 'aws-amplify/api';
import { createUserProject } from '../graphql/mutations';
import { useNavigate } from 'react-router-dom';
import './AssingUserProject.css'
import { listProjects, listUsers } from '../graphql/queries';
import JustAdminMessage from '../commons/JustAdminMessage';
import { getUserByUsernameWithProjects } from '../custom_queries';

const client = generateClient();

function AssignUserProjectForm(props) {
  const [showForm, setShowForm] = useState(true);

  const navigate = useNavigate();
  const handleProjectPage = () => {
    navigate("/admin")
  }

  const { tokens } = useTheme();

  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [allUsers, setAllUsers] = useState([]);
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedUserLabel, setSelectedUserLabel] = useState('');
  const [selectedProjectLabel, setSelectedProjectLabel] = useState('');
  const [error, setError] = useState('');
  const [isDuplicated, setIsDuPlicated] = useState(false);

  useEffect(() => {
    const fetchUsersHandler = async () => {
      const result = await fetchUsers();
      setAllUsers(result)
      const resultToAutocomplete = result.map(user => ({ id: user.id, label: user.username }))
      setUsers(resultToAutocomplete);
    };
    const fetchProjectsHandler = async () => {
      const result = await fetchProjects();
      const resultToAutocomplete = result.map(project => ({ id: project.id, label: project.name }))
      setProjects(resultToAutocomplete);
    };
    fetchUsersHandler();
    fetchProjectsHandler();
  }, []);

  const fetchUsers = async () => {
    try {
      const response = await client.graphql({ query: listUsers });
      return response.data.listUsers.items;
    } catch (err) {
      console.log('error fetching users', err);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await client.graphql({ query: listProjects });
      return response.data.listProjects.items;
    } catch (err) {
      console.log('error fetching projects', err);
    }
  };

  const handleCreate = async (event) => {
    event.preventDefault();
    setIsDuPlicated(false);
    if (!selectedUser && !selectedProject) {
      setError('Por favor seleccione un usuario y un proyecto.');
      return;
    } else if (!selectedUser) {
      setError('Por favor seleccione un usuario.');
      return;
    } else if (!selectedProject) {
      setError('Por favor seleccione un proyecto.');
      return;
    }
    setError('');

    // obtenemos el usuario completo
    const selectUserObj = allUsers.filter((obj) => obj.id === selectedUser);

    // Obtenemos los proyectos asignados al usuario
    const currentProjectsByUser = await fetchProjectsByUser(selectUserObj[0].username);

    const duplicatedProject = currentProjectsByUser.filter((obj) => obj.project.id === selectedProject)

    if (duplicatedProject.length === 0) {
      try {
        const newUserProject = await client.graphql({
          query: createUserProject,
          variables: {
            input: {
              projectId: selectedProject,
              userId: selectedUser
            }
          }
        })
        console.log("Project assing successfully");
        setShowForm(false);
        return newUserProject;
      }
      catch (error) {
      console.error("Error assing project:", error);
      throw error;
    }
  } else {
    setIsDuPlicated(true);
    console.log("El proyecto ya ha sido asignado a este usuario");
  }
  return false;
  }

  const fetchProjectsByUser = async (username) => {
    try {
      const response = await client.graphql({
        query: getUserByUsernameWithProjects,
        variables: {
          username: username
        }
      });
      return response.data.getUserByUsername.items[0].projects.items;
    } catch (e) {
      console.log('Something went wrong', e);
      return [];
    }
  };

  const handleClear = async () => {
    setSelectedProject('');
    setSelectedUser('');
    setSelectedProjectLabel('');
    setSelectedUserLabel('');
  }

  return (
    <>
      {props.role === 'Administrador' ? (
        <View style={formStyle} font="font.inverse">
          {
            isDuplicated && <>
            {/* <h3 backgroundColor = 'red'>El proyecto ya ha sido asignado a este usuario</h3> */}
            <Text color="red">Este proyecto ya ha sido asignado a este usuario</Text>
          </>
          }
          {showForm ? (
            <>
              <h4>Asigna un proyecto</h4>
              <div>
                {error && (
                  <Flex justifyContent="center" margin="1rem">
                    <Text color="red">{error}</Text>
                  </Flex>
                )}
                <Grid
                  templateColumns="1fr"
                  templateRows="6rem 6rem 3rem"
                  gap={tokens.space.small}
                >
                  <Autocomplete
                    label="Autocomplete placeholder example"
                    options={users}
                    value={selectedUserLabel}
                    placeholder="Search for user..."
                    menuSlots={{
                      Empty: <View>No users found :(</View>,
                    }}
                    className='customSearch1'
                    onSelect={({ id, label }) => { setSelectedUser(id); setSelectedUserLabel(label) }}
                    onClear={() => { setSelectedUser(''); setSelectedUserLabel('') }}
                    onBlur={() => !selectedUser && setSelectedUser('') && setSelectedUserLabel('')}
                  />
                  <Autocomplete
                    label="Autocomplete placeholder example"
                    options={projects}
                    value={selectedProjectLabel}
                    placeholder="Search for project..."
                    menuSlots={{
                      Empty: <View>No projects found :(</View>,
                    }}
                    className='customSearch2'
                    onSelect={({ id, label }) => { setSelectedProject(id); setSelectedProjectLabel(label) }}
                    onClear={() => { setSelectedProject(''); setSelectedProjectLabel('') }}
                    onBlur={() => !selectedProject && setSelectedProject('') && setSelectedProjectLabel('')}
                  />
                </Grid>
                <Grid
                  templateColumns="1fr 1fr 1fr"
                  templateRows="1rem 1rem 1rem"
                  gap={tokens.space.small}
                >
                  <Button
                    className='button-create-assing'
                    onClick={handleClear}
                  // columnSpan={}
                  >Limpiar</Button>
                  <Button
                    className='button-create-assing'
                    onClick={handleProjectPage}
                  >Cancelar</Button>
                  <Button
                    className='button-create-assing'
                    onClick={handleCreate}
                  >Asignar</Button>
                </Grid>
              </div>
            </>
          ) : (
            <>
              <h4>Proyecto asignado correctamente</h4>
              <Button
                padding='0.5rem'
                margin='1rem'
                variation="primary"
                onClick={() => { setShowForm(true); }}
              >Asignar otro proyecto</Button>
              <Button
                padding='0.5rem'
                margin='1rem'
                variation="primary"
                onClick={handleProjectPage}
              >Volver a Proyectos</Button>
            </>
          )}
        </View>

      ) : (
        <JustAdminMessage />
      )}

    </>



  );
}

const formStyle = {
  // padding: '50px 20px',
  backgroundColor: '#282c34',
  padding: '1rem',
  // width: '30rem',
  height: '28rem',
  color: 'white'
};

export default AssignUserProjectForm;

